import Progress from './progress';
import './styles/index.scss';
const StyledProgress = Progress;
StyledProgress.displayName = 'Progress';
export default StyledProgress;
